import { render, staticRenderFns } from "./DetailSurgeryAddElement.vue?vue&type=template&id=4586e671&scoped=true&"
import script from "./DetailSurgeryAddElement.vue?vue&type=script&lang=js&"
export * from "./DetailSurgeryAddElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4586e671",
  null
  
)

export default component.exports